import { render } from "./BillingInvoices.vue?vue&type=template&id=4e935354&ts=true"
import script from "./BillingInvoices.vue?vue&type=script&lang=ts"
export * from "./BillingInvoices.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__